import { MERCATELY_API } from '../../constants/AppConstants';
import abstractModel from '../../core/MercatelyModel';

const resource = `${MERCATELY_API}/conversation_topics`;

const model = abstractModel(resource);

model.fetchTopics = async () => model.get();

model.createTopic = async (params) => model.save(params);

model.deleteTopic = async (params) => model.remove(params);

model.editTopic = async (params) => model.save(params);

export default model;
